export default __webpack_public_path__ + "static/media/SEA_7362.7e7cc9a6.jpg";